var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscoverLogoWhite = function SvgDiscoverLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    "aria-label": "discover",
    viewBox: "0 0 38 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3",
    opacity: 0.07
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7A7A7",
    d: "M37 16.95V21c0 1.1-.9 2-2 2H23.228c7.896-1.815 12.043-4.601 13.772-6.05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    d: "M9 11h20v2H9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A7A7A7",
    d: "M22 12c0 1.7-1.3 3-3 3s-3-1.4-3-3 1.4-3 3-3c1.7 0 3 1.3 3 3"
  })));
};
export { SvgDiscoverLogoWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHJvbGU9ImltZyIgdmlld0JveD0iMCAwIDM4IDI0IiB3aWR0aD0iMzgiIGhlaWdodD0iMjQiIGFyaWEtbGFiZWw9ImRpc2NvdmVyIj48dGl0bGUgaWQ9InBpLWRpc2NvdmVyIj5EaXNjb3ZlcjwvdGl0bGU+PHBhdGggZD0iTTM1IDBIM0MxLjMgMCAwIDEuMyAwIDN2MThjMCAxLjcgMS40IDMgMyAzaDMyYzEuNyAwIDMtMS4zIDMtM1YzYzAtMS43LTEuNC0zLTMtM3oiIGZpbGw9IiMwMDAiIG9wYWNpdHk9Ii4wNyIvPjxwYXRoIGQ9Ik0zNSAxYzEuMSAwIDIgLjkgMiAydjE4YzAgMS4xLS45IDItMiAySDNjLTEuMSAwLTItLjktMi0yVjNjMC0xLjEuOS0yIDItMmgzMiIgZmlsbD0iI0ZGRiIvPjxwYXRoIGQ9Ik0zNyAxNi45NVYyMWMwIDEuMS0uOSAyLTIgMkgyMy4yMjhjNy44OTYtMS44MTUgMTIuMDQzLTQuNjAxIDEzLjc3Mi02LjA1eiIgZmlsbD0iI0E3QTdBNyIvPjxwYXRoIGZpbGw9IiM0OTQ5NDkiIGQ9Ik05IDExaDIwdjJIOXoiLz48cGF0aCBkPSJNMjIgMTJjMCAxLjctMS4zIDMtMyAzcy0zLTEuNC0zLTMgMS40LTMgMy0zYzEuNyAwIDMgMS4zIDMgM3oiIGZpbGw9IiNBN0E3QTciLz48L3N2Zz4=";